import axios from 'axios';

export const updateUser = async (headers, data, userId) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_USER_BASE_URL}/${userId}`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
